export default __webpack_public_path__ + "static/media/Completion of Phase I Ramp-Up at Punjab Facility.d6d59adc.pdf";